import { render, staticRenderFns } from "./DfrCompanyAggregate.vue?vue&type=template&id=816cf48e&scoped=true"
import script from "./DfrCompanyAggregate.vue?vue&type=script&lang=js"
export * from "./DfrCompanyAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816cf48e",
  null
  
)

export default component.exports